import { createBlimoApi } from '@blimo/api-client';

export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? '', // leer = gleiche Herkunft (Vite-Proxy lokal)
  portalUrl: import.meta.env.VITE_PORTAL_URL ?? 'http://localhost:5174',
};

export const api = createBlimoApi({ baseUrl: env.apiUrl });
